module.exports = __webpack_public_path__ + "static/media/Mayur Kongutte.ea5fe18c.jpg";